/*
  Copyright (c) 2015 Stephen Sorensen

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
  THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  Original Source: https://github.com/spudly/error-subclass/tree/v2.0.4
  Modified to include `message` in !Error.captureStackTrace fallback,
    and handle initialization in CS.
*/

interface ErrorSubclass extends Error {
  message: string;
  name: string;
  stack?: string;
  toString(): string;
}

interface ErrorSubclassConstructor {
  new (message?: string): ErrorSubclass;
  (message?: string): void;
  prototype: ErrorSubclass;
}

const ErrorSubclass = function ErrorSubclass(this: ErrorSubclass, message?: string): void {
  Error.call(this, message);
  Object.defineProperty(this, 'message', {value: message ?? ''});
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    Object.defineProperty(this, 'stack', {value: new Error(message).stack});
  }
} as ErrorSubclassConstructor;

ErrorSubclass.prototype = Object.create(Error.prototype, {
  name: {
    get(): string {
      return this.constructor.name;
    },
  },
});

ErrorSubclass.prototype.constructor = ErrorSubclass; // CS finds super with this.

ErrorSubclass.prototype.toString = function toString(this: ErrorSubclass): string {
  return `${this.name}: ${this.message}`;
};

export default ErrorSubclass;
